import React from 'react';
import { Anchor } from '@mantine/core';
import PropTypes from 'prop-types';

const AppAnchor = ({ disabled, underline, children, ...rest }) => (
  <Anchor
    {...rest}
    style={{
      fontSize: 14,
      ...rest.style,
      cursor: disabled ? 'not-allowed' : 'pointer',
      color: disabled ? '#666' : rest.style?.color || 'dodgerblue'
    }}
    underline={disabled ? 'none' : underline || 'hover'}
  >
    {children}
  </Anchor>
);

AppAnchor.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  underline: PropTypes.string
};

export default AppAnchor;
